export default "__VITE_ASSET__257aa8cb__"